// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__0UFHV","spin":"Spinner_spin__7nxi4"};